import React from 'react';
import styled from 'styled-components';

import { ModalContainer } from 'shared/modals';
import { CountdownModal } from 'src/components/modals/countdown-modal';

export const EndSessionModal = ({
  startNewSession,
  isOpen,
  handleCloseModal,
}: {
  startNewSession: () => void;
  isOpen: boolean;
  handleCloseModal: () => void;
}): JSX.Element => (
  <StyledModalContainer
    isOpen={isOpen}
    onRequestClose={handleCloseModal}
    width='820px'
    alignItems='center'
    padding='40px'
    borderRadius='20px'
    ariaHideApp={false}
  >
    <CountdownModal
      startNewSession={startNewSession}
      closeAndContinue={handleCloseModal}
      timeLeftInSeconds={10}
      title='Are you sure you want to end the session?'
      subtitle='You will lose any items currently in your cart and have to start over.'
      primaryButtonText='Cancel & start over'
      secondaryButtonText='Keep Shopping'
    />
  </StyledModalContainer>
);

const StyledModalContainer = styled(ModalContainer)`
  max-height: 500px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 40px;
  justify-content: center;
  border-radius: 20px;

  a,
  button {
    -webkit-tap-highlight-color: transparent;
    touch-action: manipulation;
    user-select: none;
  }
`;
